import { render, staticRenderFns } from "./PartnerParamList.vue?vue&type=template&id=382932c8&scoped=true"
import script from "./PartnerParamList.vue?vue&type=script&lang=js"
export * from "./PartnerParamList.vue?vue&type=script&lang=js"
import style0 from "./PartnerParamList.vue?vue&type=style&index=0&id=382932c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382932c8",
  null
  
)

export default component.exports